import {Component, Input, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {CdkAccordionItem} from '@angular/cdk/accordion';
import {camelCase} from 'lodash';
import {isInIframe} from '../../helpers/maporium.validators';

@Component({
  selector: 'maporium-accordion-item',
  templateUrl: './maporium-accordion-item.component.html',
  styleUrls: ['./maporium-accordion-item.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    CdkAccordionItem
  ]
})
export class MaporiumAccordionItemComponent implements OnInit {
  @Input() sections = 0;
  @Input() title = '';

  @Input() iconClass: string | undefined;
  private readonly EXPAND_STORAGE_KEY = 'maporium-accordion-item-expand';

  get isExpanded() {
    if (isInIframe()) return true;
    const storedState = localStorage.getItem(this.EXPAND_STORAGE_KEY);
    const storedStateObject = storedState ? JSON.parse(storedState) : {
      [camelCase(this.title)]: true
    };
    return storedStateObject[camelCase(this.title)] ?? true;
  }

  ngOnInit(): void {
    const storedState = localStorage.getItem(this.EXPAND_STORAGE_KEY);
    if (!storedState) {
      localStorage.setItem(this.EXPAND_STORAGE_KEY, JSON.stringify({
        styles: true,
        comments: true,
        properties: true,
        // Dialog sections
        people: true,
        access: true,
        configuration: true,
        'embed code': true,
        alignment: true,
        highlighting: true,
        other: true,
        experimental: true,
        // Settings dialog sections - additional ones
        'aiAssistance': true,  // 'AI Assistance' in camelCase
        'appearance': true,     // 'Appearance' in camelCase
        'performance': true,    // 'Performance' in camelCase
        'creditsBalance': true, // AI Usage dialog section
      }));
    }
  }

  onExpand() {
    const storedState = localStorage.getItem(this.EXPAND_STORAGE_KEY);
    const storedStateObject = storedState ? JSON.parse(storedState) : {};
    storedStateObject[camelCase(this.title)] = !storedStateObject[camelCase(this.title)];
    localStorage.setItem(this.EXPAND_STORAGE_KEY, JSON.stringify(storedStateObject));
  }
}
